
import React from 'react';
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface MatchFilterProps {
  showHomeAwayOnly: boolean;
  setShowHomeAwayOnly: (value: boolean) => void;
  homeTeam?: string;
  awayTeam?: string;
}

const MatchFilter: React.FC<MatchFilterProps> = ({
  showHomeAwayOnly,
  setShowHomeAwayOnly,
  homeTeam = "",
  awayTeam = ""
}) => {
  return <div className="flex items-center space-x-2 mb-4">
      <Switch id="home-away-filter" checked={showHomeAwayOnly} onCheckedChange={setShowHomeAwayOnly} />
      <Label htmlFor="home-away-filter">
        Show only current {homeTeam} home vs {awayTeam} away matches
      </Label>
    </div>;
};

export default MatchFilter;
